import { alpha, Chip as MuiChip, styled } from '@material-ui/core';
import { indicatorTypePalette, palette } from '../../settings/themes/colors';

const INDICATOR_TYPE_PREFIX = 'indicador_';

const outlinedVariant = borderColor => ({
  backgroundColor: palette.white,
  color: `${palette.darkGray} !important`,
  border: `2px solid ${borderColor}`,
  height: 'auto',
  minHeight: 32,
  padding: '4px 0',
  '& > span': {
    whiteSpace: 'normal'
  }
});

const getIndicatorTypeVariant = type => {
  if (!type.startsWith(INDICATOR_TYPE_PREFIX)) return undefined;

  const color = indicatorTypePalette[type.slice(INDICATOR_TYPE_PREFIX.length)];

  return outlinedVariant(color || alpha(palette.dimGray, 0.4));
};

export const getIndicatorChipType = levelType => `${INDICATOR_TYPE_PREFIX}${levelType}`;

export const Chip = styled(MuiChip)(({ type = 'default' }) => {
  let variantAttr = {};

  switch (type) {
    case 'legally_incorporated':
      variantAttr = {
        backgroundColor: palette.emerald,
        color: palette.white
      };
      break;
    case 'unincorporated':
      variantAttr = {
        backgroundColor: palette.white,
        color: `${palette.dimGray} !important`,
        border: `1px solid ${palette.dimGray}`
      };
      break;
    case 'in_the_process_of_incorporation':
      variantAttr = {
        backgroundColor: palette.white,
        color: `${palette.emerald} !important`,
        border: `1px solid ${palette.emerald}`
      };
      break;
    case 'active':
      variantAttr = { backgroundColor: palette.captuDataYellow };
      break;
    case 'inactive':
      variantAttr = { backgroundColor: palette.silver };
      break;
  }

  return {
    borderRadius: 8,
    border: `1px solid ${alpha(palette.dimGray, 0.2)}`,
    color: `${palette.white} !important`,
    fontWeight: 'bold',
    width: 'fit-content',
    ...variantAttr,
    ...getIndicatorTypeVariant(type)
  };
});
